import React from 'react';
import { Grid, TextField } from '@mui/material';
import { DialogStructure } from '../../../core/DialogStructure';
import { CustomEditor } from '../../../core/CustomEditor';

interface IProps {
  open: boolean;
  subject: string;
  body: string;
  setSubject: (val: string) => void;
  setBody: (val: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const GwGRejectDialog: React.FC<IProps> = ({
  open,
  subject,
  body,
  setSubject,
  setBody,
  onSave,
  onCancel,
}) => {
  return (
    <DialogStructure
      open={open}
      title='Ablehnung'
      onSave={onSave}
      onCancel={onCancel}
      titleVariant='h6'
      maxWidth='md'
      disableSave={!subject || !body}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            size='small'
            fullWidth
            label='Betreff'
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomEditor txt={body} setTxt={setBody} />
        </Grid>
      </Grid>
    </DialogStructure>
  );
};
